import { useState, useEffect } from 'react';

import { Text, Title, Group, Badge, Button, Image, Stack, Divider, Spoiler, Box, Flex, Avatar } from '@mantine/core';
import { Link } from '@inertiajs/react';
import { Post } from './types';
import { IconPencil, IconMicrophone, IconPlayerPlay, IconLibraryPhoto } from '@tabler/icons-react';

interface PostDrawerContentProps {
  post: Post;
  title: string;
  slug: string;
  image_url?: string | null;
  published_at?: string;
  dance_styles: { id: number; name: string }[];
  postTypeIcons?: React.ReactNode;
  post_types?: { id: number; name: string }[];
  baseImage?: string;
  body?: any;
  onCardClick?: (post: Post) => void;
}
export default function PostDrawerContent({ post }: PostDrawerContentProps) {
  const { slug, title, image_url, published_at, dance_styles, postTypeIcons, post_types } = post;
  useEffect(() => {
    console.log('Post received in drawer:', post);
  }, [post]);

  const publishedDate = published_at
    ? new Date(published_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
    : null;

  const postTypeIconMap: Record<string, React.ReactNode> = {
    Blog: <IconPencil size={12} />,
    Podcast: <IconMicrophone size={12} />,
    Video: <IconPlayerPlay size={12} />,
    Carousel: <IconLibraryPhoto size={12} />,
  };

  return (
    <Stack gap="xs" color="gray" style={{ width: '100%', minHeight: '100vh', height: 'auto', paddingBottom: '10rem' }}>
      {post.image_url && (
        <Box style={{ overflow: 'hidden', position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <Image src={post.image_url} alt={post.title || 'Post'} radius="md" fit="contain" style={{ width: '100%' }} />
          {post_types && post_types.length > 0 && (
            <Group gap="xs" style={{ position: 'absolute', top: 8, left: 8 }}>
              {post_types.map((type) => (
                <Badge
                  key={type.id}
                  variant="filled"
                  color="rgba(0, 0, 0, 0.63)"
                  size="lg"
                  className="poppins"
                  leftSection={postTypeIconMap[type.name]}
                >
                  {type.name}
                </Badge>
              ))}
            </Group>
          )}
        </Box>
      )}
      <Title fw={500} size="lg" className="rubik-header" style={{ lineHeight: 1 }}>
        {post.title}
      </Title>
      {/* Published date */}
      {publishedDate && (
        <Text size="sm" className="poppins mt-1" style={{ fontSize: 16, color: '#d1d1d1' }}>
          Published: {publishedDate} by {post.author.name}
        </Text>
      )}
      {/* Dance style badges */}
      {dance_styles.length > 0 && (
        <Group gap="xs" mt="xs">
          {dance_styles.slice(0, 3).map((style) => (
            <Badge key={style.id} variant="filled" color="#EA580C" radius="xl" size="xs" className="tag-badge">
              {style.name}
            </Badge>
          ))}
          {dance_styles.length > 3 && (
            <Text size="xs" className="poppins" style={{ color: '#d1d1d1', fontSize: 12 }}>
              + {dance_styles.length - 3}
            </Text>
          )}
        </Group>
      )}
      <Divider color="#757575" mt={0} mb={16} />
      <Spoiler
        maxHeight={250}
        mt="0"
        showLabel="Read more"
        hideLabel="Show less"
        color="orange"
        classNames={{
          control: 'custom-spoiler-control',
        }}
      >
        <Text
          mt="xs"
          dangerouslySetInnerHTML={{ __html: post.body }}
          style={{ color: '#FFF7ED' }}
          className="event-description"
        />
      </Spoiler>
    </Stack>
  );
}
